import React, { useEffect, useState } from "react";
import TokenDetails from "./TokenDetails";
import DeveloperSignupForm from "./DeveloperSignUpForm";
// import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { useGlobal } from "../Context/globalContext";
import Loader from "../Components/Loader";

const DeveloperAccessPage = () => {
    const {developerInfo} = useGlobal();
    const [hasAccess, setHasAccess] = useState(false);

    useEffect(() => {
        const role = developerInfo?.role;
        if (role === "developer") {
            setHasAccess(true);
        }
    }, [developerInfo?.role]);

    const handleSuccess = () => {
        setHasAccess(true);
    };



    return (
        <>
            {!developerInfo ? <Box display="flex" justifyContent="center" alignItems="center" height="300px">
                <Loader />
            </Box>   : hasAccess ? (
                <TokenDetails />
            ) : (
                <DeveloperSignupForm onSuccess={handleSuccess} />
            )}
        </>
    );
};

export default DeveloperAccessPage;
